import { Component, computed } from '@angular/core';
import { CraftCalculatorStateService } from '../craft-calculator-state.service';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { SubsectionComponent } from 'src/app/shared/components/subsection/subsection.component';
import { Location } from 'src/app/shared/models/location.model';
import { OutputItem } from 'src/app/shared/models/craft-models/craft-models';
import { CheckPriceButtonComponent } from 'src/app/shared/components/check-price-button/check-price-button.component';
import { CopyTextButtonComponent } from 'src/app/shared/components/copy-text-button/copy-text-button.component';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { ItemImageComponent } from 'src/app/shared/components/item-image/item-image.component';

@Component({
  selector: 'app-craft-calculator-selling',
  imports: [CommonModule, SectionComponent, SubsectionComponent, CheckPriceButtonComponent, CopyTextButtonComponent, MatCardModule, MatChipsModule, MatIconModule, MatFormFieldModule, ItemImageComponent],
  templateUrl: './craft-calculator-selling.component.html',
  styleUrl: './craft-calculator-selling.component.scss',
})
export class CraftCalculatorSellingComponent {
  public outputItemsGroupedBySellLocation = computed(() => {
    const grouped: Map<Location, { items: OutputItem[]; totalWeight: number }> = new Map();

    const craftGroup = this.craftCalculatorStateService.craftGroup();
    if (!craftGroup) {
      return [];
    }

    craftGroup
      .outputItems()
      .filter((item) => item.totalAmount() > 0)
      .forEach((item) => {
        const location = item.sellLocation();
        if (location) {
          if (!grouped.has(location)) {
            grouped.set(location, { items: [], totalWeight: 0 });
          }
          const group = grouped.get(location)!;
          group.items.push(item);
          group.totalWeight += item.totalWeight();
        }
      });

    // Convert Map to Array for template iteration
    return Array.from(grouped.entries());
  });

  constructor(public craftCalculatorStateService: CraftCalculatorStateService) {}
}
